import BaseService from "services/BaseService";
import _ from "lodash";

class WorkSpaceService extends BaseService {
    list = async () => {
        var data = await this._api.post("master/workspace/list",);
        return data;
    }

    packageList = async () => {
        return await this._api.post("master/workspace/packages");
    }

    renew = async ({ w_id, package_key, duration_months }) => {
        return await this._api.post("master/workspace/renew", { w_id, package_key, duration_months });
    }

  



}
export default WorkSpaceService;
